import {
  priceStrategyConfigUpdateSchema,
  priceStrategyConfigWithRelationsSchema,
} from '@snap-types/models/price-strategy-config';
import { z } from 'zod/v4';

import { columns, columnValidators } from './columns';

export const snapSiteConfigSchema = z.object(columns);

export type SnapSiteConfig = z.output<typeof snapSiteConfigSchema>;

export const snapSiteConfigInsertSchema = snapSiteConfigSchema.omit({
  uuid: true,
  createdAt: true,
  updatedAt: true,
  deletedAt: true,
});

export type InsertableSnapSiteConfig = z.output<
  typeof snapSiteConfigInsertSchema
>;

export const snapSiteConfigWithRelationsSchema = z.object({
  ...columns,
  // priceStrategies: z.array(priceStrategyConfigWithRelationsSchema).default([]),
  // @NOTE(shawk): z.unknown() is a workaround for zod type inference issues
  priceStrategies: z
    .unknown()
    .pipe(z.array(priceStrategyConfigWithRelationsSchema))
    .default([]),
});

export type SnapSiteConfigWithRelations = z.output<
  typeof snapSiteConfigWithRelationsSchema
>;

export const snapSiteConfigUpdateSchema = z.object(columnValidators);

export type UpdatableSnapSiteConfig = z.input<
  typeof snapSiteConfigUpdateSchema
>;

export const snapSiteConfigEditSchema = z.object({
  ...snapSiteConfigUpdateSchema.shape,
  priceStrategies: priceStrategyConfigUpdateSchema.array().default([]),
});

export type SnapSiteConfigEditFormDataUnvalidated = z.input<
  typeof snapSiteConfigEditSchema
>;

export type SnapSiteConfigEditFormData = z.output<
  typeof snapSiteConfigEditSchema
>;
